// wow this file is a product of a late late night
import api from "@/api";

export default {
  namespaced: true,

  state: {
    searchQuery: "",
    searchType: "All",
    searchIndexes: {
      Policies: false,
      Forms: false,
      Pages: true,
      News: true,
      Events: true,
      Questions: true,
      ExternalSystems: true,
    },
    searchResults: {
      Policies: [],
      Forms: [],
      Pages: [],
      News: [],
      Events: [],
      Questions: [],
      ExternalSystems: [],
    },
    resultCount: 0,
  },

  mutations: {
    SET_SEARCH_QUERY(state, term) {
      state.searchQuery = term;
    },
    SET_SEARCH_TYPE(state, searchType) {
      state.searchType = searchType;
    },
    TOGGLE_INDEXES(state, val) {
      Object.keys(state.searchIndexes).forEach((index) => {
        state.searchIndexes[index] = val;
      });
    },
    SET_SEARCH_INDEX(state, { index, val }) {
      state.searchIndexes[index] = val;
    },
    SET_QUERY(state, val) {
      state.searchQuery = val;
    },
    SET_TYPE(state, val) {
      state.searchType = val;
    },
    ADD_SEARCH_RESULTS(state, { name, results }) {
      state.searchResults[name] = results;
    },
    CLEAR_RESULTS(state) {
      state.searchResults = {
        Policies: [],
        Forms: [],
        Pages: [],
        News: [],
        Events: [],
        Questions: [],
        ExternalSystems: [],
      };
    },
  },

  actions: {
    reindex() {
      return new Promise((resolve, reject) => {
        api()
          .get("/search/reindex")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            resolve(error.response.data);
            // reject(error);
          });
      });
    },

    setSearchIndexes({ state, commit }) {
      // determine what we are searching for first
      commit("TOGGLE_INDEXES", false);
      switch (state.searchType.toLowerCase()) {
        case "policies":
          commit("SET_SEARCH_INDEX", { index: "Policies", val: false });
          break;
        case "forms":
          commit("SET_SEARCH_INDEX", { index: "Forms", val: false });
          break;
        case "pages":
          commit("SET_SEARCH_INDEX", { index: "Pages", val: true });
          break;
        case "news":
          commit("SET_SEARCH_INDEX", { index: "News", val: true });
          break;
        case "events":
          commit("SET_SEARCH_INDEX", { index: "Events", val: true });
          break;
        case "questions":
          commit("SET_SEARCH_INDEX", { index: "Questions", val: true });
          break;
        case "external":
          commit("SET_SEARCH_INDEX", { index: "ExternalSystems", val: true });
          break;
        default:
          commit("TOGGLE_INDEXES", true);
          break;
      }
    },

    async siteSearch({ state, commit, dispatch }) {
      // determine what indexes we are checking first
      dispatch("setSearchIndexes");

      let filter;

      let response;

      // then build stuff up
      // if (state.searchIndexes.Policies) {
      //   filter = {
      //     size: 10000,
      //     query: {
      //       bool: {
      //         must: [
      //           {
      //             match: {
      //               policy_title: {
      //                 query: state.searchQuery,
      //                 operator: 'and',
      //                 zero_terms_query: 'all',
      //               },
      //             },
      //           },
      //           {
      //             term: {
      //               status: 'approved',
      //             },
      //           },
      //         ],
      //       },
      //     },
      //   };
      //   try {
      //     response = await api().put('/policymanagement/policies/flat', { filter });
      //     commit('ADD_SEARCH_RESULTS', {
      //       name: 'Policies',
      //       results: response.data.data.policy,
      //     });
      //   } catch (error) {
      //     commit('ADD_SEARCH_RESULTS', {
      //       name: 'Policies',
      //       results: [],
      //     });
      //   }
      // }

      // if (state.searchIndexes.Forms) {
      //   filter = {
      //     size: 10000,
      //     query: {
      //       bool: {
      //         must: [
      //           {
      //             match: {
      //               form_title: {
      //                 query: state.searchQuery,
      //                 operator: 'and',
      //                 zero_terms_query: 'all',
      //               },
      //             },
      //           },
      //           {
      //             term: {
      //               status: 'approved',
      //             },
      //           },
      //         ],
      //       },
      //     },
      //   };
      //   try {
      //     response = await api().put('/formmanagement/forms/flat', { filter });
      //     commit('ADD_SEARCH_RESULTS', {
      //       name: 'Forms',
      //       results: response.data.data.form,
      //     });
      //   } catch (error) {
      //     commit('ADD_SEARCH_RESULTS', {
      //       name: 'Forms',
      //       results: [],
      //     });
      //   }
      // }

      if (state.searchIndexes.Pages) {
        filter = {
          size: 50,
          query: {
            bool: {
              must: [
                {
                  bool: {
                    should: [
                      {
                        match: {
                          title: {
                            query: state.searchQuery,
                            operator: "and",
                            zero_terms_query: "all",
                            fuzziness: "AUTO",
                          },
                        },
                      },
                      {
                        match_phrase_prefix: {
                          title: {
                            query: state.searchQuery,
                            slop: 50,
                          },
                        },
                      },
                      {
                        match: {
                          elements_content: {
                            query: state.searchQuery,
                            operator: "and",
                            zero_terms_query: "all",
                            fuzziness: "AUTO",
                          },
                        },
                      },
                      {
                        match_phrase_prefix: {
                          elements_content: {
                            query: state.searchQuery,
                            slop: 50,
                          },
                        },
                      },
                    ],
                  },
                },
                {
                  terms: {
                    status: ["approved", "pending"],
                  },
                },
              ],
            },
          },
        };
        try {
          response = await api().put("/content/pages/flat", { filter });
          commit("ADD_SEARCH_RESULTS", {
            name: "Pages",
            results: response.data.data.page,
          });
        } catch (error) {
          commit("ADD_SEARCH_RESULTS", {
            name: "Pages",
            results: [],
          });
        }
      }
      if (state.searchIndexes.News) {
        filter = {
          size: 50,
          query: {
            bool: {
              must: [
                {
                  term: {
                    status: "approved",
                  },
                },
                {
                  bool: {
                    should: [
                      {
                        match: {
                          tag_names: {
                            query: state.searchQuery,
                            operator: "and",
                            zero_terms_query: "all",
                            fuzziness: "AUTO",
                          },
                        },
                      },
                      {
                        bool: {
                          should: [
                            {
                              match: {
                                title: {
                                  query: state.searchQuery,
                                  operator: "and",
                                  zero_terms_query: "all",
                                  fuzziness: "AUTO",
                                },
                              },
                            },
                            {
                              match_phrase_prefix: {
                                title: {
                                  query: state.searchQuery,
                                  slop: 50,
                                },
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        };
        try {
          response = await api().put("/news/articles/web/flat", { filter });
          commit("ADD_SEARCH_RESULTS", {
            name: "News",
            results: response.data.data.article,
          });
        } catch (error) {
          commit("ADD_SEARCH_RESULTS", {
            name: "News",
            results: [],
          });
        }
      }

      if (state.searchIndexes.Events) {
        filter = {
          size: 50,
          query: {
            bool: {
              should: [
                {
                  match: {
                    title: {
                      query: state.searchQuery,
                      operator: "and",
                      zero_terms_query: "all",
                      fuzziness: "AUTO",
                    },
                  },
                },
                {
                  match_phrase_prefix: {
                    title: {
                      query: state.searchQuery,
                      slop: 50,
                    },
                  },
                },
              ],
            },
          },
        };
        try {
          response = await api().put("/schedule/events/flat", { filter });
          commit("ADD_SEARCH_RESULTS", {
            name: "Events",
            results: response.data.data.event,
          });
        } catch (error) {
          commit("ADD_SEARCH_RESULTS", {
            name: "Events",
            results: [],
          });
        }
      }
      if (state.searchIndexes.Questions) {
        filter = {
          size: 50,
          query: {
            bool: {
              must: [
                {
                  bool: {
                    should: [
                      {
                        match: {
                          title: {
                            query: state.searchQuery,
                            operator: "and",
                            zero_terms_query: "all",
                            fuzziness: "AUTO",
                          },
                        },
                      },
                      {
                        match_phrase_prefix: {
                          title: {
                            query: state.searchQuery,
                            slop: 50,
                          },
                        },
                      },
                    ],
                  },
                },
                {
                  term: {
                    status: "active",
                  },
                },
              ],
            },
          },
        };
        try {
          response = await api().put("/collaboration/questions/flat", {
            filter,
          });
          commit("ADD_SEARCH_RESULTS", {
            name: "Questions",
            results: response.data.data.question,
          });
        } catch (error) {
          commit("ADD_SEARCH_RESULTS", {
            name: "Questions",
            results: [],
          });
        }
      }
      if (state.searchIndexes.ExternalSystems) {
        filter = {
          size: 10000,
          query: {
            bool: {
              must: [
                {
                  bool: {
                    should: [
                      {
                        match: {
                          name: {
                            query: state.searchQuery,
                            operator: "and",
                            zero_terms_query: "all",
                            fuzziness: "AUTO",
                          },
                        },
                      },
                      {
                        match_phrase_prefix: {
                          name: {
                            query: state.searchQuery,
                            slop: 50,
                          },
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        };
        try {
          response = await api().put("/system/externals/flat", { filter });
          commit("ADD_SEARCH_RESULTS", {
            name: "ExternalSystems",
            results: response.data.data.external,
          });
        } catch (error) {
          commit("ADD_SEARCH_RESULTS", {
            name: "ExternalSystems",
            results: [],
          });
        }
      }
    },
  },

  getters: {
    // loop through all keys, get total of results
    totalResults: (state) =>
      Object.keys(state.searchResults).reduce(
        (acc, key) => acc + state.searchResults[key].length,
        0
      ),
  },
};
